// extracted by mini-css-extract-plugin
export default {"headerBlue":"FundingRequirementsView_headerBlue","tooltip":"FundingRequirementsView_tooltip","container":"FundingRequirementsView_container"};